import { graphql, useFragment } from 'react-relay';

import { type useShowSellerSince_viewer$key } from './__generated__/useShowSellerSince_viewer.graphql.ts';
import { type useShowSellerSince_seller$key } from './__generated__/useShowSellerSince_seller.graphql.ts';

const NEW_SELLER_SINCE_THRESHOLD = 6;

const viewerFragment = graphql`
    fragment useShowSellerSince_viewer on Viewer {
        suppressNewSellerSignals: featureFlag(feature: "suppressNewSellerSignals")
    }
`;

const sellerFragment = graphql`
    fragment useShowSellerSince_seller on Seller {
        dealerSince
        monthsSinceStartDate: timeSinceStartDate(unit: MONTH)
    }
`;

export const useShowSellerSince = ({
    viewer: viewerRef,
    seller: sellerRef,
}: {
    viewer: useShowSellerSince_viewer$key;
    seller: useShowSellerSince_seller$key | null | undefined;
}): boolean => {
    const viewer = useFragment(viewerFragment, viewerRef);
    const seller = useFragment(sellerFragment, sellerRef);

    const { suppressNewSellerSignals } = viewer;
    const { dealerSince, monthsSinceStartDate } = seller || {};

    const isNewSeller = monthsSinceStartDate && monthsSinceStartDate <= NEW_SELLER_SINCE_THRESHOLD;
    return !!(dealerSince && (!isNewSeller || !suppressNewSellerSignals));
};
